import { render, staticRenderFns } from "./yc-put-seedling.vue?vue&type=template&id=126765a1&"
import script from "./yc-put-seedling.vue?vue&type=script&lang=js&"
export * from "./yc-put-seedling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports